module.exports = __webpack_public_path__ + "img/presidentialsweet_room_image04.0dc9bdc2.jpg";